"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleVehicleAccessoriesOnOrderMutation = void 0;
const fragments_1 = require("../../types/next/fragments");
exports.toggleVehicleAccessoriesOnOrderMutation = `
  mutation toggleVehicleAccessoriesOnOrder($orderId: ID!, $addAccessories: [VehicleAccessoryInput!], $removeAccessories: [String!]) {
    toggleVehicleAccessoriesOnOrder(orderId: $orderId, addAccessories: $addAccessories, removeAccessories: $removeAccessories) {
      ...order
      ...nextError
    }
  }
  ${fragments_1.orderFragments}
  ${fragments_1.nextErrorFragment}
`;
//# sourceMappingURL=vehicle-accessory.js.map